
import * as __star__ from '@clayui/label';

const {
default: __default__,
ItemAfter,
ItemBefore,
ItemExpand,
__esModule
} = __star__;

export {
ItemAfter,
ItemBefore,
ItemExpand,
__esModule
};
export default __default__;
